import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type GoogleBusinessIconProps = React.ComponentPropsWithRef<'svg'>;

export function GoogleBusinessIcon({ ...restProps }: GoogleBusinessIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <path
                    d="M3.273 1.636C2.537 1.636 1.91 2.128 1.705 2.796L0 9.272C0 10.936 1.336 12.272 3 12.272C3.79565 12.272 4.55871 11.9559 5.12132 11.3933C5.68393 10.8307 6 10.0677 6 9.272C6 10.936 7.336 12.272 9 12.272C9.79565 12.272 10.5587 11.9559 11.1213 11.3933C11.6839 10.8307 12 10.0677 12 9.272C12 10.922 13.35 12.272 15 12.272C16.664 12.272 18 10.936 18 9.272C18 10.936 19.336 12.272 21 12.272C22.664 12.272 24 10.936 24 9.272L22.295 2.796C22.1914 2.46077 21.9834 2.16742 21.7013 1.95874C21.4192 1.75007 21.0779 1.63699 20.727 1.636H3.273ZM12.002 10.962C11.398 12.025 10.299 12.772 9 12.772C7.696 12.772 6.602 12.025 6 10.966C5.396 12.026 4.298 12.772 3 12.772C2.516 12.772 2.056 12.672 1.637 12.495V20.727C1.637 21.627 2.373 22.364 3.273 22.364H20.727C21.627 22.364 22.363 21.627 22.363 20.727V12.495C21.9319 12.6781 21.4683 12.7723 21 12.772C19.696 12.772 18.602 12.026 18 10.968C17.398 12.026 16.304 12.772 15 12.772C13.701 12.772 12.606 12.022 12.002 10.962ZM17.727 14.727C18.535 14.727 19.215 15.025 19.734 15.509L18.875 16.368C18.566 16.0739 18.1535 15.9133 17.727 15.921C16.747 15.921 15.955 16.748 15.955 17.727C15.955 18.707 16.747 19.534 17.727 19.534C18.609 19.534 19.212 19.033 19.342 18.343H17.727V17.183H20.553C20.588 17.379 20.607 17.583 20.607 17.796C20.607 19.51 19.46 20.727 17.727 20.727C16.9314 20.727 16.1683 20.4109 15.6057 19.8483C15.0431 19.2857 14.727 18.5226 14.727 17.727C14.727 16.9314 15.0431 16.1683 15.6057 15.6057C16.1683 15.0431 16.9314 14.727 17.727 14.727Z"
                    fill="white"
                />
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <path
                d="M21.3738 6.77049H2.03752C1.57808 6.77049 1.20564 7.14294 1.20564 7.60237V21.641C1.20564 22.1005 1.57808 22.4729 2.03752 22.4729H21.3738C21.8332 22.4729 22.2056 22.1005 22.2056 21.641V7.60237C22.2056 7.14294 21.8332 6.77049 21.3738 6.77049Z"
                fill="#4989F5"
            />
            <path
                d="M21.1311 6.65252H2.25699C1.67233 6.65252 1.21737 11.1773 1.21737 11.762L11.5534 22.4729H21.1311C21.7175 22.4713 22.1925 21.9963 22.1941 21.4098V7.71538C22.1924 7.129 21.7174 6.65412 21.1311 6.65252Z"
                fill="url(#paint0_linear_115_4043)"
            />
            <path d="M6.00068 9.40012H12.0007V1.52523H6.8991L6.00068 9.40012Z" fill="#3C4BA6" />
            <path
                d="M18.0007 9.40012H12.0007V1.52523H17.1023L18.0007 9.40012ZM22.2056 3.01801L22.2131 3.04485C22.2113 3.03538 22.2077 3.02658 22.2056 3.01801Z"
                fill="#7BABF7"
            />
            <path
                d="M22.2131 3.04463L22.2056 3.01778C22.0154 2.14672 21.2444 1.52557 20.3529 1.525H17.1023L18 9.40011H24L22.2131 3.04463Z"
                fill="#3F51B5"
            />
            <path
                d="M1.79571 3.01801L1.78827 3.04485C1.79007 3.03537 1.79368 3.02658 1.79571 3.01801Z"
                fill="#7BABF7"
            />
            <path
                d="M1.78805 3.04463L1.79549 3.01778C1.98571 2.14672 2.75668 1.52557 3.64827 1.525H6.8991L6 9.40011H0L1.78805 3.04463Z"
                fill="#7BABF7"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.01083 9.39809C6.01083 11.054 4.66843 12.3964 3.01252 12.3964C1.35661 12.3964 0.0142097 11.054 0.0142097 9.39809H6.01083Z"
                fill="#709BE0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0074 9.39809C12.0074 11.054 10.665 12.3964 9.00913 12.3964C7.35322 12.3964 6.01083 11.054 6.01083 9.39809H12.0074Z"
                fill="#3C4BA6"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0041 9.39809C18.0041 11.054 16.6617 12.3964 15.0058 12.3964C13.3498 12.3964 12.0074 11.054 12.0074 9.39809H18.0041Z"
                fill="#709BE0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 9.39809C24 11.054 22.6576 12.3964 21.0017 12.3964C19.3458 12.3964 18.0034 11.054 18.0034 9.39809H24Z"
                fill="#3C4BA6"
            />
            <path
                d="M20.6886 17.492C20.6793 17.3688 20.6638 17.2563 20.6417 17.1126H17.7622C17.7622 17.5074 17.7622 17.9382 17.7606 18.3333H19.4287C19.3933 18.5174 19.3211 18.6928 19.2163 18.8494C19.1115 19.0061 18.9762 19.1409 18.8181 19.2461C18.8181 19.2461 18.8181 19.2393 18.8169 19.2391C18.6127 19.3706 18.3827 19.4586 18.1417 19.4975C17.9 19.5408 17.6523 19.5397 17.4111 19.4944C17.1661 19.4447 16.9342 19.3461 16.7297 19.2049C16.4279 18.995 16.1951 18.7034 16.0599 18.3658C16.0495 18.3395 16.04 18.313 16.0303 18.2861V18.2832L16.0329 18.2813C15.9016 17.9037 15.9013 17.4941 16.0319 17.1163C16.1239 16.8512 16.2752 16.6098 16.4749 16.4096C16.9433 15.9346 17.6432 15.7559 18.2884 15.9466C18.5359 16.021 18.7619 16.1515 18.9484 16.3274L19.5112 15.7757C19.6104 15.6774 19.7135 15.5822 19.809 15.4806C19.5237 15.2196 19.1887 15.0163 18.8232 14.8821C18.1581 14.6457 17.4305 14.6394 16.7613 14.8644C16.738 14.8722 16.7148 14.8803 16.6918 14.8887C15.9698 15.1548 15.3758 15.6766 15.0272 16.3512C14.9041 16.5899 14.8145 16.8439 14.7607 17.1062C14.4419 18.6592 15.4086 20.1879 16.9692 20.5988C17.4794 20.7327 18.0217 20.7294 18.5359 20.615C19.003 20.5116 19.435 20.2915 19.7898 19.9762C20.1599 19.6423 20.4253 19.1975 20.5643 18.725C20.6805 18.3246 20.7226 17.907 20.6886 17.492Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_115_4043"
                    x1="1.21737"
                    y1="7352.62"
                    x2="22320.3"
                    y2="7352.62"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.03" stopColor="#4079D8" />
                    <stop offset="1" stopColor="#4989F5" />
                </linearGradient>
            </defs>
        </svg>
    );
}
